import { useEffect, useState } from 'react';

import { SimpleHouseType } from 'types/corelogic';
import { Risks } from 'types/suncorpRisks';

import { HardwareStore } from './useFetchScriptVariables';

export interface ReportSessionData {
  ADDRESS_NUMBER?: string;
  ADDRESS_STREET?: string;
  REGION?: string;
  POSTCODE?: string;
  PLACES?: HardwareStore[];
  HOME_TYPE?: SimpleHouseType;
  RISKS: Risks | null;
}

const useReportSessionData = () => {
  const [data, setData] = useState<ReportSessionData | undefined | null>(
    undefined
  );

  useEffect(() => {
    const sessionData = JSON.parse(
      sessionStorage.getItem('report_data') ?? 'null'
    );

    setData(sessionData);
  }, []);

  return data;
};

export default useReportSessionData;
